import Vue from 'vue';

Vue.filter('toKm', (value: number): number => +(value / 1000).toFixed(2));
